module.exports = __webpack_public_path__ + "static/media/imgop_WinterWheatStraw_StretchedTiff.9be65a6d.png";